/**
 * Amplitude Experiment feature flag keys (must match flags defined in Amplitude UI).
 * Add keys here as flags are created in Experiment; consumers use {@link useAmplitudeFeatureFlag}.
 */
export enum AMPLITUDE_FEATURE_FLAGS {
  /** Lease audits: Hot Spots sub-tab showing recurring failure patterns across properties */
  HOTSPOT = 'hotspot',
  /** Lease audits: recoverable revenue Impact column on audit tables; must match Amplitude Experiment key */
  LEASE_AUDIT_FINANCIAL_IMPACT_UI = 'lease-audit-financial-impact-ui',
  /** Property Transitions customer UI rollout; must match Amplitude Experiment key */
  PROPERTY_TRANSITIONS_UI = 'property-transitions-ui',
  /** Lease audit explicit rerun UI (#8879); must match Amplitude Experiment key */
  LEASE_AUDIT_EXPLICIT_RERUN = 'lease-audit-explicit-rerun',
  /**
   * Lease audits: Check Type column in place of Failure Type, the AI Issue Status column,
   * the Needs Customer Input request-type filter, and the link from a blocked issue to its
   * comments (#10349); must match Amplitude Experiment key
   */
  LEASE_AUDIT_CHECK_TYPE_AND_ISSUE_STATUS_UI = 'lease-audit-check-type-and-issue-status-ui',
  /** Property Health: regroup an expanded financial report by property or occupancy type; must match Amplitude Experiment key */
  LEASE_AUDIT_REPORT_GROUPING = 'lease-audit-report-grouping',
  /** Property transitions Key Data / variable catalog; must match Amplitude Experiment key */
  TRANSITION_VARIABLES = 'transition-variables',
  /** What's New dialog, archive page, and account-menu link; must match Amplitude Experiment key */
  WHATS_NEW = 'whats-new',
  /** Document management customer UI; must match Amplitude Experiment key */
  DOCUMENT_MANAGEMENT = 'document-management',
  /**
   * Lease audit run documents: reconciled-documents API and document timeline;
   * must match Amplitude Experiment key
   */
  USE_RECONCILED_DOCUMENTS_API = 'use-reconciled-documents-api',
  /**
   * Lease audits: consolidated expandable table on Home and All audits
   * (resident-first lease cell, expand-left, shared columns); must match
   * Amplitude Experiment key
   */
  LEASE_AUDIT_CONSOLIDATED_TABLE = 'lease-audit-consolidated-table',
  /**
   * Surface Agent panel, topbar toggle, sidebar entry, and fullscreen page
   * for property transitions; must match Amplitude Experiment key
   */
  SURFACE_AGENT_PROPERTY_TRANSITIONS = 'surface-agent-property-transitions',
}
